import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/img/question.png';
const _hoisted_1 = {
  class: "support-list"
};
const _hoisted_2 = {
  class: "support-list-header"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_5 = {
  class: "search-box"
};
const _hoisted_6 = {
  class: "select-type-box"
};
const _hoisted_7 = {
  class: "search-input-box"
};
const _hoisted_8 = {
  class: "search-count"
};
const _hoisted_9 = {
  class: "support-list-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_selected = _resolveComponent("adaptive-selected");
  const _component_el_input = _resolveComponent("el-input");
  const _component_search = _resolveComponent("search");
  const _component_ide_table = _resolveComponent("ide-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('message.Support')) + " ", 1), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$setup.options.now.length ? (_openBlock(), _createBlock(_component_adaptive_selected, {
    key: 0,
    modelValue: $setup.select,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.select = $event),
    options: $setup.options.now,
    onChange: $setup.handleSelectChange
  }, null, 8, ["modelValue", "options", "onChange"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
    modelValue: $setup.search,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.search = $event),
    class: _normalizeClass(["search-input", {
      paddingEn: $setup.lang === 'en',
      paddingZh: $setup.lang === 'zh'
    }]),
    onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers($event => $setup.handleSearchInput($setup.search), ["stop"]), ["enter"]))
  }, null, 8, ["modelValue", "class"]), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('message.Found')) + " " + _toDisplayString($setup.list.length) + " " + _toDisplayString(_ctx.$t('message.Results')), 1), _createVNode(_component_search, {
    class: "search-icon",
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $setup.handleSearchInput($setup.search), ["stop"]))
  })])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_ide_table, {
    column: $setup.column,
    "row-height": 100,
    list: $setup.list,
    noMore: $setup.noMore,
    onOperation: $setup.handleClickDownload,
    onLoadMore: $setup.handleLoadMore,
    ref: "ideTableRef"
  }, null, 8, ["column", "list", "noMore", "onOperation", "onLoadMore"])])]);
}